import { cn } from "@omni/utils/styles";

import { useUspContext } from "@/components/Blocks/usps/components/context/usp.context";

type Props = { className?: string };

export const Icon = ({ className }: Props) => {
    const { usp } = useUspContext();

    if (!usp?.icon) return null;

    return <i className={cn(`las la-lg la-${usp.icon}`, className)} />;
};
